
export const PAYLOAD_KEYS = [
  ['transId', 'Required. The Pekey.', 'The pekey to able to identify important data.', true],
  ['activityId', 'Required. The activity ID', 'The identifier of the activity', true],
  ['status', 'Required. The status', 'The status can be only the value examples', true],
  ['transAmount', 'Optional. The transaction amount', 'The money was generated by the user', false],
  ['activityName', 'Optional. The activity name', 'The name of the activity', false],
  ['rId', 'The reward ID', 'The rewardId used to create the user activity', false],
  ['stepId', 'Optional. The step ID', 'The stepId use to indentify the step. But we have other way to indentify the step.', false],
  ['slug', 'Optional. A string', 'The slug use to indentify the step.', false],
]

export const curlUrlencoded = ({ url, rewardId, transId, transAmount, activityName, activityId, status, id: stepId, slug }) => `
curl --location '${url}' \
--header 'Content-Type: application/x-www-form-urlencoded' \
--data-urlencode 'rId=${rewardId}' \
--data-urlencode 'transId=${transId}' \
--data-urlencode 'transAmount=${transAmount}' \
--data-urlencode 'activityName=${activityName}' \
--data-urlencode 'activityId=${activityId}' \
--data-urlencode 'status=${status}' \
--data-urlencode 'stepId=${stepId}' \
--data-urlencode 'slug=${slug}'
`

export const curlJson = ({ url, rewardId, transId, transAmount, activityName, activityId, status, id: stepId, slug }) => `
curl --location '${url}' \
--header 'Content-Type: application/json' \
--data '{"rId":"${rewardId}","transId":"${transId}","transAmount":"${transAmount}","activityName":"${activityName}","activityId":"${activityId}","status":"${status}","stepId":"${stepId}","slug":"${slug}"}'
`

export const copyAsJson = ({ url, rewardId, transId, transAmount, activityName, activityId, status, id: stepId, slug }) => {
  const payload = { url, rewardId, transId, transAmount, activityName, activityId, status, stepId, slug }
  return JSON.stringify(payload, null, 2)
}
